import { createApp } from 'vue';
// global css
import 'virtual:uno.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import 'element-plus/dist/index.css'; // 全局引入样式

import '@/assets/styles/index.scss';
import '@/assets/styles/global.scss';
import VueAMap, { initAMapApiLoader } from '@vuemap/vue-amap';
import { ElDialog } from 'element-plus';
import VueKonva from 'vue-konva';
import * as dateUtils from './utils/dateUTC';

// App、router、store
import App from './App.vue';
import store from './store';
import router from './router';

// 自定义指令
import directive from './directive';

// 注册插件
import plugins from './plugins/index'; // plugins

// 高亮组件
// import 'highlight.js/styles/a11y-light.css';
import 'highlight.js/styles/atom-one-dark.css';
import 'highlight.js/lib/common';
import HighLight from '@highlightjs/vue-plugin';

// svg图标
import 'virtual:svg-icons-register';
import ElementIcons from '@/plugins/svgicon';

// permission control
import './permission';

// 国际化
import i18n from '@/lang/index';
import AdvancedTable from '@/components/AdvancedTable/AdvancedTable.vue';
import advanceFilter from '@/components/advanceFilter/index.vue';
import antEmpty from '@/components/antEmpty/index.vue';
import search from '@/components/AdvancedTable/search';
import chooseMaterial from '@/views/brand/chooseMaterial.vue';
import actionWidth from '@/components/AdvancedTable/actionWidth.vue';
import exportModel from '@/components/Export/exportModel.vue';
import uploadModel from '@/components/Export/uploadModel.vue';
import NumberInput from '@/components/NumberInput/index.vue';

// vxeTable
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
VXETable.setConfig({
  zIndex: 999999,
});

// 修改 el-dialog 默认点击遮罩为允许关闭
ElDialog.props.closeOnClickModal.default = true;
initAMapApiLoader({
  key: 'a73f68af947e9331f786b4e2cbc20641',
  // securityJsCode: 'YOUR_SECURITY_CODE',
  version: '2.0',
  plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.AutoComplete', 'AMap.Geocoder', 'AMap.PlaceSearch'],
});
window._AMapSecurityConfig = {
  serviceHost: 'https://gzzry.cn/_AMapService',
};
const app = createApp(App);
app.use(VueAMap);
app.component('AdvancedTable', AdvancedTable);
app.component('advanceFilter', advanceFilter);
app.component('antEmpty', antEmpty);
app.component('search', search);
app.component('chooseMaterial', chooseMaterial);
app.component('actionWidth', actionWidth);
app.component('exportModel', exportModel);
app.component('uploadModel', uploadModel);
app.component('NumberInput', NumberInput);
// 2. 挂载到全局（$dateUtils 是自定义全局名）
app.config.globalProperties.$dateUtils = dateUtils;
// 全局注册 v-go-back 指令
app.directive('goBack', {
  mounted(el, binding) {
    // 绑定点击事件
    el.addEventListener('click', () => {
      const delta = binding.value || -1; // 指令传参作为后退页数，默认-1
      if (window.history.length > 1) {
        router.go(delta);
      } else {
        router.push('/');
      }
    });
  },
  // 解绑时移除事件监听，防止内存泄漏
  unmounted(el) {
    el.removeEventListener('click', () => {});
  },
});
// 封装「滚动到底部触发」的自定义指令 v-scroll-bottom
app.directive('scroll-bottom', {
  // 元素挂载后执行（绑定事件）
  mounted(el, binding) {
    // 定义滚动处理函数
    const scrollHandler = (e) => {
      const target = e.target;
      const { scrollTop, clientHeight, scrollHeight } = target;
      // 滚动到底部判断（阈值20px）
      const isBottom = scrollTop + clientHeight >= scrollHeight - 20;
      if (isBottom) {
        // 执行指令绑定的方法
        binding.value?.(e);
      }
    };

    // 绑定滚动事件到元素上（关键：之前没这步）
    el.addEventListener('scroll', scrollHandler);
    // 把事件处理函数存到 el 上，方便 unmounted 时移除
    el._scrollHandler = scrollHandler;
  },
  // 组件销毁时执行（解绑事件，防止内存泄漏）
  unmounted(el) {
    if (el._scrollHandler) {
      el.removeEventListener('scroll', el._scrollHandler);
      delete el._scrollHandler;
    }
  },
});
app.use(VueKonva);
app.use(HighLight);
app.use(ElementIcons);
app.use(router);
app.use(store);
app.use(i18n);
app.use(VXETable);
app.use(plugins);
// 自定义指令
directive(app);

app.mount('#app');
